import React from 'react';
import classNames from 'classnames';
import { Link } from '@sls-react/routing';

interface Props {
  className?: string;
}

const CartLink: React.FC<Props> = ({ children, className }) => (
  <Link href="/cart" passHref>
    <a
      className={classNames('relative', className)}
      aria-label="View your cart"
      rel="nofollow noindex"
    >
      {children}
    </a>
  </Link>
);

export default CartLink;
